import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/branding/'
export const SET_COLORS = NAMESPACE + 'SET_COLORS'
export const ADD_IMAGE_SETS = NAMESPACE + 'ADD_IMAGE_SETS'

const initialState = {
  colors: [],
  imageSets: {
    ids: [],
    byId: {},
  }
}

export default function reducer (state: any = initialState, action: any = {}) {
  switch (action.type) {
    case SET_COLORS:
      return {
        ...state,
        colors: action.payload.colors,
      }
    case ADD_IMAGE_SETS: {
      const newState = {
        ...state,
        imageSets: {
          ...state.imageSets,
          ids: [ ...state.imageSets.ids ],
          byId: { ...state.imageSets.byId },
        }
      }

      action.payload.imageSets.forEach(imageSet => {
        newState.imageSets.ids = addUniqueValueToArray({
          array: newState.imageSets.ids,
          value: imageSet.id,
          index: undefined,
        })
        newState.imageSets.byId[imageSet.id] = {
          ...newState.imageSets.byId[imageSet.id],
          ...imageSet,
        }
      })

      return newState
    }
    default: return state
  }
}

export function setColors ({ colors }) {
  return {
    type: SET_COLORS,
    payload: {
      colors,
    }
  }
}

export function addImageSets ({ imageSets }) {
  return {
    type: ADD_IMAGE_SETS,
    payload: {
      imageSets,
    }
  }
}
